var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "main_center",
    },
    [
      _c("iframe", {
        ref: "mainIframe",
        style: { height: _vm.documentClientHeight - 115 + "px" },
        attrs: {
          src: `${_vm.$bigDataUrl}/#/iframeLogin?token=${_vm.mainToken}&isIframe=${_vm.isIframe}&url=${_vm.url}&btnActive=${_vm.btnActive}`,
          width: "100%",
          frameborder: "0",
          scrolling: "yes",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }